<div class="col-12 flex flex-column informacion__wrapper">
  @if (_jefeHogar) {
    <CustomTitle title="Jefe de familia"
                 [styleClass]="'font-principal app-title-page-color font-medium font-18 text-uppercase mt-2 '"/>
    <section class="grid my-2 p-fluid">
      <div class="col-12 md:col-6 ">
        <label for="primerNombre"> Primer nombre</label>
        <input pInputText type="text" class="w-full  border border-gray-300 "
               id="primerNombre" readonly [value]=" _jefeHogar.primerNombre "/>
      </div>
      <div class="col-12 md:col-6 ">
        <label for="segundoNombre"> Segundo nombre</label>
        <input pInputText type="text" class="w-full  border border-gray-300 "
               id="segundoNombre" readonly [value]="_jefeHogar.segundoNombre"/>
      </div>
      <div class="col-12 md:col-6 ">
        <label for="primerApellido"> Primer apellido </label>
        <input pInputText type="text" class="w-full  border border-gray-300 "
               id="primerApellido" readonly [value]=" _jefeHogar.primerApellido"/>
      </div>
      <div class="col-12 md:col-6 ">
        <label for="segundoApellido"> Segundo Apellido </label>
        <input pInputText type="text" class="w-full  border border-gray-300 "
               id="segundoApellido" readonly [value]="_jefeHogar.segundoApellido"/>
      </div>
      <div class="col-12 md:col-6 ">
        <label for="tipoIdentificacion"> Tipo identificación </label>
        <input pInputText readonly id="tipoIdentificacion"
               class="w-full  border border-gray-300 " type="text"
               [value]=" _jefeHogar.tipoIdentificacionDescripcion"/>
      </div>

      <div class="col-12 md:col-6">
        <label for="genero"> Genero </label>
        <input pInputText readonly id="genero"
               class="w-full  border border-gray-300 " type="text"
               [value]=" _jefeHogar.generoDescripcion"/>
      </div>
      <div class="col-12 md:col-6">
        <label for="barrio"> Barrio </label>
        <input pInputText readonly id="barrio"
               class="w-full  border border-gray-300 " type="text"
               [value]=" _jefeHogar.barrio"/>
      </div>
      <div class="col-12 md:col-6">
        <label for="vinculo"> Vinculo </label>
        <input pInputText readonly id="vinculo"
               class="w-full  border border-gray-300 " type="text"
               [value]=" _jefeHogar.vinculo"/>
      </div>
      <div class="col-12 md:col-6">
        <label for="direccion"> Dirección </label>
        <input pInputText readonly id="direccion"
               class="w-full  border border-gray-300 " type="text"
               [value]=" _jefeHogar.direccion"/>
      </div>

    </section>
  }
  <div>
    <CustomTitle title="Nucleo familiar"
                 [styleClass]="'font-principal app-title-page-color font-medium font-18 text-uppercase mt-2 '"/>
  </div>
  <custom-table [config]="configTable"/>
</div>
